import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Suspense, lazy, useEffect } from "react";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Navbar from "@/components/Navbar";
import { track } from "@/lib/track";
import { CustomerAuthProvider } from "@/lib/customerAuth";
import { LanguageProvider } from "@/lib/i18n";

// Lazy-load non-critical routes for faster first paint on slow connections
const Book = lazy(() => import("@/pages/Book"));
const PrivateBooking = lazy(() => import("@/pages/PrivateBooking"));
const BookingSuccess = lazy(() => import("@/pages/BookingSuccess"));
const BookingPending = lazy(() => import("@/pages/BookingPending"));
const ManageBooking = lazy(() => import("@/pages/ManageBooking"));
const CustomerPortal = lazy(() => import("@/pages/CustomerPortal"));
const AdminLogin = lazy(() => import("@/pages/AdminLogin"));
const AdminDashboard = lazy(() => import("@/pages/AdminDashboard"));

const Fallback = () => (
  <div className="max-w-6xl mx-auto px-6 py-16 text-stone-500">Cargando…</div>
);

function RouteTracker() {
  const loc = useLocation();
  useEffect(() => {
    if (!loc.pathname.startsWith("/admin")) {
      track("page_view", { path: loc.pathname });
    }
  }, [loc.pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
          <CustomerAuthProvider>
            <RouteTracker />
            <Navbar />
            <Suspense fallback={<Fallback />}>
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/book" element={<Book />} />
                <Route path="/private" element={<PrivateBooking />} />
                <Route path="/booking/success" element={<BookingSuccess />} />
                <Route path="/booking/pending" element={<BookingPending />} />
                <Route path="/manage" element={<ManageBooking />} />
                <Route path="/cuenta" element={<CustomerPortal />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
              </Routes>
            </Suspense>
            <Toaster position="top-right" richColors />
          </CustomerAuthProvider>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
